let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("igTGi")).then(() => parcelRequire('llYLq'));